exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-header-row {\n  min-height: 25px; }\n\n.tables_wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 1rem;\n  -ms-flex-pack: center;\n      justify-content: center;\n  margin: 0 1rem 1rem 1rem; }\n  .tables_wrapper .card_users {\n    width: 100%;\n    max-width: 700px; }\n  .tables_wrapper .input_filter_type {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n    -ms-flex-align: center;\n        align-items: center;\n    gap: 2rem;\n    padding: 0 1rem; }\n    .tables_wrapper .input_filter_type .form-control {\n      width: 60%; }\n\n.card-body {\n  padding: 1.25rem 0; }\n  .card-body .hidePag {\n    display: none; }\n  .card-body .valorColuna {\n    text-align: end; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/dialog/user-perm-group-dialog/user-perm-group-dialog.component.scss
// module id = ../../../../../src/app/components/dialog/user-perm-group-dialog/user-perm-group-dialog.component.scss
// module chunks = main